import { api } from "./api";

export const postComment = async (postId: number, content: string) => {
  try {
    const body = { postId, content };
    const { data } = await api().post("/comment", body);
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const putComment = async (commentId: number, content: string) => {
  try {
    const body = { content };
    const { data } = await api().put(`/comment/${commentId}`, body);
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const deleteComment = async (commentId: number) => {
  try {
    // 성공 시 백엔드가 204 No Content 반환
    const response = await api().delete(`/comment/${commentId}`);
    return response.status >= 200 && response.status < 300;
  } catch (e) {
    console.log(e);
    return false;
  }
};